
export class RegistrationStatus {

  status: boolean;
  navigateTo: string; // MODAL, REGSUCCESS, ESIG

  constructor() {}
}
